<div class="grid-container padding-y-4">
  <fieldset class="usa-fieldset">
    <div class="grid-row">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <legend class="usa-legend usa-legend--large">FRT - BOOK SHIPMENT</legend>
      </div>
    </div>
    <div class="grid-row">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <legend class="usa-legend usa-legend--medium">Shipment Details: Book Shipment Id - {{bookShipmentInfo?.bookShipmentId?bookShipmentInfo.bookShipmentId:'No Record'}}</legend>
        <hr>
        <!-- <label class="usa-label text-left">Book Shipment Id - {{bookShipmentInfo.bookShipmentId?bookShipmentInfo.bookShipmentId:'No Record'}}</label> -->
      </div>
    </div>
    <div *ngIf="isCarrierView; else showShipperViewShipperInfo">
      <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <h4>Shipper Information</h4>
          <div class="grid-row grid-gap-1">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label class="usa-label"><span class="text-bold">Shipper : </span>{{shipperInfo ? shipperInfo.firstName : 'No Record'}} {{shipperInfo ? shipperInfo.lastName : 'No Record' }}</label>
              <!-- <label class="text-indent-105">{{shipperInfo ? shipperInfo.firstName : 'No Record'}} {{shipperInfo ? shipperInfo.lastName : 'No Record' }}</label> -->
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label class="usa-label"><span class="text-bold">Customer : </span>{{ agencyInfo ? agencyInfo.agencyBureauName : 'No Record'}}</label>
              <!-- <label class="text-indent-105">{{ agencyInfo ? agencyInfo.agencyBureauName : 'No Record'}}</label> -->
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label class="usa-label"><span class=" text-bold">Phone : </span>{{shipperInfo ? shipperInfo.phone : 'No Record' }}</label>
              <!-- <label class="text-indent-105">{{shipperInfo ? shipperInfo.phone : 'No Record' }}</label> -->
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label class="usa-label"><span class=" text-bold">Email : </span>{{shipperInfo ? shipperInfo.email : 'No Record' }}</label>
              <!-- <label class="text-indent-105">{{shipperInfo ? shipperInfo.email : 'No Record' }}</label> -->
            </div>
          </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <h4>TSP Information</h4>
          <div class="grid-row grid-gap-1">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label class="usa-label"><span class=" text-bold">SCAC : </span>{{carrier ? carrier.scac : ''}}</label>
              <!-- <label class="text-indent-105">{{carrier ? carrier.scac : ''}}</label> -->
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label class="usa-label"><span class=" text-bold">Phone : </span>{{otoInfo ? otoInfo.phone : carrierOrganizationInfo ? carrierOrganizationInfo.phone : ''}}</label>
              <!-- <label class="text-indent-105">{{carrierOrganizationInfo ? carrierOrganizationInfo.phone : ''}}</label> -->
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label class="usa-label"><span class=" text-bold">Email : </span>{{otoInfo ? otoInfo.email : carrierOrganizationInfo? carrierOrganizationInfo.email : ''}}</label>
              <!-- <label class="text-indent-105">{{carrierOrganizationInfo? carrierOrganizationInfo.email : ''}}</label> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-template #showShipperViewShipperInfo>
      <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <h4>Shipper Information</h4>
          <div class="grid-row grid-gap-1">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="name" class="usa-label">Shipper:</label>
              <input class="usa-input maxw-full" type="text" id="name" value="{{shipperInfo ? shipperInfo.firstName : ''}} {{shipperInfo ? shipperInfo.lastName : '' }}" readonly>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="agency" class="usa-label">Customer:</label>
              <input class="usa-input maxw-full" id="agency" value="{{ agencyInfo ? agencyInfo.agencyBureauName : ''}}" type="text" readonly>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="phone" class="usa-label">Phone:</label>
              <input type="text" class="usa-input maxw-full" id="phone" value="{{shipperInfo ? shipperInfo.phone : '' }}" readonly>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="email" class="usa-label">Email:</label>
              <input type="text" class="usa-input maxw-full" id="email" value="{{shipperInfo ? shipperInfo.email : '' }}" readonly>
            </div>
          </div>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <h4>TSP Information</h4>
          <div class="grid-row grid-gap-1">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="name" class="usa-label">SCAC : </label>
              <input id="scac" class="usa-input maxw-full" type="text" value="{{carrier ? carrier.scac : ''}}" readonly>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="phone" class="usa-label">TSP Contact:</label>
              <input id="phone" type="text" class="maxw-full usa-input" value="{{carrierOrganizationInfo ? carrierOrganizationInfo.firstName : ''}} {{carrierOrganizationInfo ? carrierOrganizationInfo.lastName : ''}}" readonly>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="phone" class="usa-label">Phone:</label>
              <input id="phone" type="text" class="usa-input maxw-full" value="{{otoInfo ? otoInfo.phone : carrierOrganizationInfo ? carrierOrganizationInfo.phone : ''}}" readonly>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="email" class="usa-label">Email:</label>
              <input id="email" type="text" class="usa-input maxw-full" value="{{otoInfo ? otoInfo.email : carrierOrganizationInfo ? carrierOrganizationInfo.email : ''}}" readonly>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <div class="grid-row">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <legend class="usa-legend usa-legend--medium">Shipment Information</legend>
        <hr>
      </div>
    </div>

    <form [formGroup]="frtOnlineBookShipmentForm">
      <div *ngIf="isCarrierView; else showShipperView">
        <div class="grid-row grid-gap-1">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <h4>Agency</h4>
            <div class="grid-row grid-gap-1">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label"><span class="text-bold">Agency Shipment ID No : </span>{{shipmentDetailsInfo.agencyShipmentIdNo}}</label>
                <!-- <label class="text-indent-105">{{shipmentDetailsInfo.agencyShipmentIdNo}}</label> -->
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label"><span class="text-bold">Agency Location Code : </span>{{shipmentDetailsInfo.agencyLocationCode}}</label>
                <!-- <label class="text-indent-105">{{shipmentDetailsInfo.agencyLocationCode}}</label> -->
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label"><span class="text-bold">Shipment Declared Value : </span>{{shipmentInfo.declaredValue}}</label>
                <!-- <label class="text-indent-105">{{shipmentInfo.declaredValue}}</label> -->
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label"><span class="text-bold">TSP Pro Bill No : </span>{{shipmentInfo.tspProBillNo}}</label>
                <!-- <label class="text-indent-105">{{shipmentInfo.declaredValue}}</label> -->
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label"><span class="text-bold">Pickup Date : </span>{{shipmentInfo.moveDate | date: 'MM/dd/yyyy'}}</label>
                <!-- <label class="text-indent-105">{{shipmentInfo.moveDate | date: 'MM/dd/yyyy'}}</label> -->
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label"><span class="text-bold">Required Delivery Date :</span> {{shipmentInfo.declaredValue}}</label>
                <!-- <label class="text-indent-105">{{shipmentInfo.declaredValue}}</label> -->
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label"><span class="text-bold">Mode : </span>{{shipmentDetailsInfo.shipmentMode}}</label>
                <!-- <label class="text-indent-105">{{shipmentDetailsInfo.shipmentMode}}</label> -->
              </div>
            </div>
          </div>

          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <h4>Location</h4>
            <div class="grid-row grid-gap-1">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="origin" class="usa-label"><span class="text-bold">Origin : </span>{{originAddress}}
                  <span *ngIf="!originAddress && originCountry != ''">{{originCountry}}</span></label>
                <!-- <label class="text-indent-105"></label> -->
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="destination" class="usa-label"><span class="text-bold"> Destination : </span>{{destinationAddress}}
                  <span *ngIf="!destinationAddress && destinationCountry != ''">{{destinationCountry}}</span></label>
                <!-- <label class="text-indent-105">{{destinationAddress}}
                  <span *ngIf="!destinationAddress && destinationCountry != ''">{{destinationCountry}}</span></label> -->
              </div>
            </div>
          </div>

          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <h4>Others</h4>
            <div class="grid-row grid-gap-1">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="requestedPackingDate" class="usa-label"> <span class="text-bold"> Estimated Mileage : </span>{{shipmentInfo.miles? shipmentInfo.miles: 'No Record'}}</label>
                <!-- <label class="text-indent-105"></label> -->
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="estimatedWeight" class="usa-label"><span class="text-bold">Estimated Weight :</span>{{shipmentInfo.weight?shipmentInfo.weight:'No Record'}}</label>
                <!-- <label class="text-indent-105"> {{shipmentInfo.weight?shipmentInfo.weight:'No Record'}}</label> -->
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="shipmentInfo.noOfFleetVehicles">
                <label for="estimatedWeight" class="usa-label"> <span class="text-bold">No. of Fleet Vehicles : </span>{{shipmentInfo.noOfFleetVehicles?shipmentInfo.noOfFleetVehicles:'No Record'}}</label>
                <!-- <label class="text-indent-105">{{shipmentInfo.noOfFleetVehicles?shipmentInfo.noOfFleetVehicles:'No Record'}}</label> -->
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="SRO" class="usa-label"> <span class="text-bold">SRO : </span>{{ ratesSroInfo?.sroType? ratesSroInfo?.sroType:'No Record'}}</label>
                <!-- <label class="text-indent-105">{{ ratesSroInfo?.sroType? ratesSroInfo?.sroType:'No Record'}}</label> -->
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="totalShipmentCube" class="usa-label"> <span class="text-bold"> Total Shipment Cube(Cubic Feet) :</span>{{shipmentInfo.shipmentCubicFeet?shipmentInfo.shipmentCubicFeet:'No Record'}} </label>
                <!-- <label class="text-indent-105">{{shipmentInfo.shipmentCubicFeet?shipmentInfo.shipmentCubicFeet:'No Record'}}</label> -->
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="contactPurchaseOrderNo" class="usa-label"><span class="text-bold">Contract Purchase Order No : </span>
                  <button type="button" class="usa-button margin-left-2" id="contractOrder" (click)="openSealOrPurchaseModal('purchaseorder', 'Purchase Orders')">View</button>
                </label>

              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="sealNumbers" class="usa-label"><span class="text-bold">Seal Numbers : </span>
                  <button type="button" class="usa-button" id="sealNo" (click)="openSealOrPurchaseModal('seal', 'Seal Numbers')">View</button>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="grid-row grid-gap-1" *ngIf="!isOneTimeShipment">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <legend class="usa-legend usa-legend--medium">Shipment Cost Information</legend>
            <hr>
          </div>
        </div>
        <div class="grid-row grid-gap-1" *ngIf="!isOneTimeShipment">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label class="usa-label"><span class=" text-bold">Type Of Rate :</span>{{ rateTypesInfo?.description?rateTypesInfo?.description:'No Record' }} </label>
            <!-- <label class="text-indent-105"></label> -->
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label class="usa-label"><span class=" text-bold">Tender Id :</span> {{ ratesFrtInfo?.tenderId? ratesFrtInfo?.tenderId: 'No Record' }}</label>
            <!-- <label class="text-indent-105">{{ ratesFrtInfo?.tenderId? ratesFrtInfo?.tenderId: 'No Record' }}</label> -->
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label class="usa-label"><span class=" text-bold">Linehaul Cost :</span> {{shipmentCostInfo?.linehaulCost?(shipmentCostInfo?.linehaulCost | currency) : 'No Record'}} <span class="fa-info-circle blue-500" aria-hidden="true" tooltip="{{linehaulCalculation}}"></span></label>
            <!-- <label class="text-indent-105">{{shipmentCostInfo?.linehaulCost?(shipmentCostInfo?.linehaulCost | currency) : 'No Record'}} <span class="fa-info-circle blue-500" aria-hidden="true" tooltip="{{linehaulCalculation}}"></span></label> -->
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label class="usa-label"><span class=" text-bold">Total Transportation Cost : </span>{{shipmentCostInfo?.totalCost ? (shipmentCostInfo?.totalCost | currency) :'No Record'}}</label>
            <!-- <label class="text-indent-105">{{shipmentCostInfo?.totalCost ? (shipmentCostInfo?.totalCost | currency) :'No Record'}}</label> -->
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4" *ngIf="!isOneTimeShipment">
            <label class="usa-label"><span class=" text-bold">Fuel Surcharge Cost : </span>{{shipmentCostInfo?.fuelSurchargeCost ? (shipmentCostInfo?.fuelSurchargeCost | currency) : 'No Record'}}</label>
            <!-- <label class="text-indent-105">{{shipmentCostInfo?.fuelSurchargeCost ? (shipmentCostInfo?.fuelSurchargeCost | currency) : 'No Record'}}</label> -->
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4" *ngIf="isOneTimeShipment">
            <label class="usa-label"><span class=" text-bold">Tender Id : </span>OTO {{shipmentCostInfo.totalCost | currency}} ON {{bookShipmentInfo.oneTimeOnlyQuoteDate | date: 'MM/dd/yyyy'}} {{bookShipmentInfo.oneTimeOnlyQuoteNumber}}</label>
            <!-- <label class="text-indent-105">OTO {{shipmentCostInfo.totalCost | currency}} ON {{bookShipmentInfo.oneTimeOnlyQuoteDate | date: 'MM/dd/yyyy'}} {{bookShipmentInfo.oneTimeOnlyQuoteNumber}}</label> -->
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4" *ngIf="!shipmentInfo.noOfFleetVehicles">
            <label class="usa-label"><span class=" text-bold">Accessorial Cost : </span>{{accessorialCost ? (accessorialCost | currency) :'No Record'}}
              <button type="button" class="usa-button margin-left-2" (click)="enterAccessorialModal()"> Accessorials</button>
            </label>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label class="usa-label">Origin, Destination & Other Addressess :
              <button type="button" class="usa-button margin-left-2" (click)="enterAddressModal()">
                Addresses
              </button>
            </label>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label class="usa-label">View Package Information :
              <button type="button" class="usa-button margin-left-2" (click)="openPackageModal()">Package Information</button>
            </label>
          </div>
        </div>
        <div class="grid-row grid-gap-1" *ngIf="!isOneTimeShipment">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <legend class="usa-legend usa-legend--medium">Comments / Status</legend>
            <hr>
          </div>
        </div>
        <div class="grid-row grid-gap-1" *ngIf="!isOneTimeShipment">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <h4>Comments</h4>
            <div class="grid-row grid-gap-1">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="!isOneTimeShipment">
                <label class="usa-label">Shipper Additional Comments:(Maximum 500 chars)</label>
                <textarea class="usa-textarea maxw-full" formControlName="additionalComments" maxlength="500" [attr.disabled]="!isCarrierView?null:true"></textarea>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="!isOneTimeShipment">
                <div class="usa-label">TSP Additional Comments:(Maximum 500 chars)</div>
                <textarea class="usa-textarea maxw-full" formControlName="tspAdditionalComments" maxlength="500" [attr.disabled]="isCarrierView?null:true"></textarea>
              </div>
            </div>
          </div>

          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <h4>Status</h4>
            <div class="grid-row grid-gap-1">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label">Booking Status: {{bookShipmentInfo.bookingStatus}}</label>
              </div>
              <div *ngIf="isCarrierView && !isOneTimeShipment && bookShipmentInfo.bookingStatus !== 'Booked'">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                  <label class="usa-label">Accept/Refuse Booking</label>
                  <select class="usa-select maxw-full" (change)="acceptRefuseBookingChanged($event.target.value)" formControlName="carrierAcceptRefuseStatus" [disabled]="disabled">
                    <option *ngFor="let item of carrierAcceptRefuseOptions" [value]="item">{{item}}</option>
                  </select>
                </div>
                <div *ngIf="acceptRejectionWithReason">
                  <div id="accept" *ngIf="isAcceptedWithQualificationByCarrier; else isRefusedByCarrier">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                      <label class="usa-label">Ready For Acceptance With Qualifications<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
                      <select class="usa-select maxw-full" (change)="acceptedWithQualificationReasonChanged($event.target.value)" formControlName="carrierAcceptOption">
                        <option *ngFor="let item of carrierAcceptOptions" [value]="item">{{item}}</option>
                      </select>
                      <div class="define-text-secondary" *ngIf="!this.frtOnlineBookShipmentForm.controls['carrierAcceptOption'].valid">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                          <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg>Acceptance is not Valid
                      </div>
                    </div>
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="acceptSpecifyReason">
                      <label class="usa-label">Specify Reason</label>
                      <input type="text" id="specifyAcceptReason" class="usa-input maxw-full" formControlName="carrierAcceptReason">
                      <div class="define-text-secondary" *ngIf="!this.frtOnlineBookShipmentForm.controls['carrierAcceptReason'].valid">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                          <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg>Specific Reason is not valid
                      </div>
                    </div>
                  </div>
                  <ng-template #isRefusedByCarrier>
                    <div id="refuse" class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                      <label class="usa-label">Reason For Refusal<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
                      <select class="usa-select maxw-full" (change)="refusedReasonChanged($event.target.value)" formControlName="carrierRefuseOption">
                        <option *ngFor="let item of carrierRejectOptions" [value]="item">{{item}}</option>
                      </select>
                      <div class="define-text-secondary" *ngIf="!this.frtOnlineBookShipmentForm.controls['carrierRefuseOption'].valid">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                          <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg>Reason For Refusal is not valid
                      </div>
                    </div>
                    <div *ngIf="rejectSpecifyReason" class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                      <label class="usa-label">Specify Reason<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
                      <input type="text" id="specifyRejectReason" class="usa-input maxw-full" formControlName="carrierRefuseReason">
                      <div class="define-text-secondary" *ngIf="!this.frtOnlineBookShipmentForm.controls['carrierRefuseReason'].valid">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                          <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg>Specific Reason is not valid
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-template #showShipperView>
        <div class="grid-row grid-gap-1">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <div class="grid-row grid-gap-1">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label" for="shipId">Agency Shipment ID No:</label>
                <input type="text" id="shipId" class="usa-input maxw-full" maxlength="18" formControlName="agencyShipmentIdNo">
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label" for="locationCode">Agency Location Code:</label>
                <input type="text" class="usa-input maxw-full" id="locationCode" formControlName="agencyLocationCode">
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label" for="frt-ship-val">Shipment Declared Value<abbr title="required" class="usa-hint usa-hint--required">*</abbr>:</label>
                <input type="text" class="usa-input maxw-full" placeholder="Enter Value Here" id="frt-ship-val" formControlName="declaredValue" />
                <div class="define-text-secondary" *ngIf="this.frtOnlineBookShipmentForm.get('declaredValue').hasError('numeric')">
                  <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                  </svg>Shipment Declared Value should be all numeric only
                </div>
                <div class="define-text-secondary" *ngIf="this.frtOnlineBookShipmentForm.get('declaredValue').value > 100000">
                  <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                  </svg>FMP max coverage is $100,000.00. Please contact TSP and additional charges may apply.
                </div>
                <div class="define-text-secondary" *ngIf="(this.frtOnlineBookShipmentForm.get('declaredValue').value === '' ||
                                                           this.frtOnlineBookShipmentForm.get('declaredValue').value === null) &&
                                                          (this.frtOnlineBookShipmentForm.get('declaredValue').touched ||
                                                           this.frtOnlineBookShipmentForm.get('declaredValue').dirty)">
                  <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                  </svg>Shipment Declared Value is required
                </div>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label" for="frt-ship-val">TSP Pro Bill No:</label>
                <input type="text" class="usa-input maxw-full" placeholder="Enter Value Here" id="pro-bill-val" [maxLength]="22" formControlName="tspProBillNo" />
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <div class="grid-row grid-gap-0">
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    <label class="usa-label" for="move-date">Pickup Date<abbr title="required" class="usa-hint usa-hint--required">*</abbr>:</label>
                    <input type="text" class="usa-input maxw-full" id="move-date" formControlName="moveDate" placeholder="mm/dd/yyyy" bsDatepicker [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }" [minDate]="minDate" (bsValueChange)="bsValueChange($event, 'moveDate')" />
                    <ng-container *ngFor="let validation of validationMessages.moveDate">
                      <div class="define-text-secondary" *ngIf="frtOnlineBookShipmentForm.get('moveDate').hasError(validation.type)
                                                                                    &&(frtOnlineBookShipmentForm.get('moveDate').dirty
                                                                                    || frtOnlineBookShipmentForm.get('moveDate').touched)">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                          <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg> {{ validation.message }}
                      </div>
                      <div class="define-text-secondary" *ngIf="this.frtOnlineBookShipmentForm.get('moveDate').hasError('dateCompare')">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                          <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg>Pickup/Move Date should not be greater than Required Delivery Date
                      </div>
                    </ng-container>
                  </div>

                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="pickup-time" class="usa-label">Pickup Time Range:</label>
                    <div class="grid-row grid-gap-0">
                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                        <label for="pickup-time-from" class="usa-label">From</label>
                        <div class="grid-row grid-gap-0">
                          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                            <timepicker id="pickup-time-from" formControlName="pickupTimeFrom" [mousewheel]="false"  [showSpinners]="false" [showMeridian]="false"></timepicker>
                            <div class="define-text-secondary" *ngIf="this.frtOnlineBookShipmentForm.get('pickupTimeFrom').hasError('outOfRange')">
                              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                              </svg>Time should be in range (0-12) and Minute should be in range (0-60).
                            </div>
                          </div>
                          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
                            <select name="meridian" id="meridian" formControlName="pickupTimeFromMeridian" class="usa-select" style="margin-top:0">
                              <option value="AM">AM</option>
                              <option value="PM">PM</option>
                            </select>
                          </div>
                        </div>
                      </div>


                    </div>
                    <div class="grid-row grid-gap-0">
                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                        <label for="pickup-time-to" class="usa-label">To</label>
                        <div class="grid-row grid-gap-0">
                          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                            <timepicker id="pickup-time-to" class="define-timepicker" [mousewheel]="false" formControlName="pickupTimeTo"  [showSpinners]="false" [showMeridian]="false"></timepicker>
                            <div class="define-text-secondary" *ngIf="this.frtOnlineBookShipmentForm.get('pickupTimeTo').hasError('outOfRange')">
                              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                              </svg>Time should be in range (0-12) and Minute should be in range (0-60).
                            </div>
                          </div>
                          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
                            <select name="meridian" id="meridian" formControlName="pickupTimeToMeridian" class="usa-select" style="margin-top:0">
                              <option value="AM">AM</option>
                              <option value="PM">PM</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <div class="grid-row grid-gap-0">
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    <label class="usa-label" for="delivery-date">
                      <abbr title="required" class="usa-hint usa-hint--required">*</abbr>Required Delivery Date:
                    </label>
                    <input type="text" class="usa-input maxw-full" id="delivery-date" formControlName="requiredDeliveryDate"
                           placeholder="mm/dd/yyyy" bsDatepicker [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }" [minDate]="minDate"
                           (bsValueChange)="bsValueChange($event, 'requiredDeliveryDate')" />
                    <ng-container *ngFor="let validation of validationMessages.requiredDeliveryDate">
                      <div class="define-text-secondary"
                           *ngIf="frtOnlineBookShipmentForm.get('requiredDeliveryDate').hasError(validation.type) &&
                                                                                                      (frtOnlineBookShipmentForm.get('requiredDeliveryDate').dirty || frtOnlineBookShipmentForm.get('requiredDeliveryDate').touched)">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                          <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg>{{ validation.message }}
                      </div>
                      <div class="define-text-secondary"
                           *ngIf="this.frtOnlineBookShipmentForm.get('requiredDeliveryDate').hasError('dateCompare')">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                          <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg> Required Delivery Date should not be less than Pickup/Move Date
                      </div>
                    </ng-container>
                    <div class="define-text-secondary" *ngIf="deliveryDateWarning === true">
                      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                      </svg> Overriding a standard transit time for CONUS motor freight shipments should get accepted by TSP
                    </div>
                  </div>

                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="pickup-time" class="usa-label">Delivery Time Range</label>
                    <div class="grid-row grid-gap-0">
                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                        <label for="delivery-time-from" class="usa-label">From</label>
                        <div class="grid-row grid-gap-0">
                          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                            <timepicker id="delivery-time-from" class="define-timepicker" [mousewheel]="false" formControlName="deliveryTimeFrom"  [showSpinners]="false" [showMeridian]="false"></timepicker>
                            <div class="define-text-secondary" *ngIf="this.frtOnlineBookShipmentForm.get('deliveryTimeFrom').hasError('outOfRange')">
                              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                              </svg>Time should be in range (0-12) and Minute should be in range (0-60).
                            </div>
                          </div>
                          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
                            <select name="meridian" id="meridian" formControlName="deliveryTimeFromMeridian" class="usa-select" style="margin-top:0">
                              <option value="AM">AM</option>
                              <option value="PM">PM</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="grid-row grid-gap-0">
                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                        <label for="delivery-time-to" class="usa-label">To</label>
                        <div class="grid-row grid-gap-0">
                          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                            <timepicker id="delivery-time-to" class="define-timepicker" [mousewheel]="false" formControlName="deliveryTimeTo"  [showSpinners]="false" [showMeridian]="false"></timepicker>
                            <div class="define-text-secondary" *ngIf="this.frtOnlineBookShipmentForm.get('deliveryTimeTo').hasError('outOfRange')">
                              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                              </svg>Time should be in range (0-12) and Minute should be in range (0-60).
                            </div>
                          </div>
                          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
                            <select name="meridian" id="meridian" formControlName="deliveryTimeToMeridian" class="usa-select" style="margin-top:0">
                              <option value="AM">AM</option>
                              <option value="PM">PM</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label" for="mode">Mode:</label>
                <select id="mode" class="usa-select maxw-full" formControlName='shipmentMode'>
                  <option *ngFor="let type of shipmentModes" value="{{type}}">{{ type }}</option>
                </select>
              </div>
              <!-- <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" >
                  <label class="usa-label" for="inputEstinmatedWeight">Estimated Weight</label>
                  <input class="usa-input maxw-full" type="number" id="inputEstinmatedWeight" formControlName="inputEstimatedWeight" (change)="onChangeEstimatedWeight()" />
              </div> -->
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="isOneTimeShipment">
                <label class="usa-label"> Rate Quote Amount: </label>
                <input class="usa-input maxw-full" type="text" formControlName="totalCost" [maxlength]="12">
              </div>
            </div>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <div class="grid-row grid-gap-1">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" >
                <label class="usa-label" for="inputEstinmatedWeight">Estimated Weight</label>
                <input class="usa-input" type="number" id="inputEstinmatedWeight" formControlName="inputEstimatedWeight" (change)="onChangeEstimatedWeight()" />
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label"><span class=" text-bold">Origin : </span>{{originAddress}} <span *ngIf="!originAddress && originCountry != ''">{{originCountry}}</span></label>
                <!-- <label class="text-indent-105">{{originAddress}} <span *ngIf="!originAddress && originCountry != ''">{{originCountry}}</span></label> -->
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label"><span class=" text-bold">Destination : </span>  {{destinationAddress}}<span *ngIf="!destinationAddress && destinationCountry != ''">{{destinationCountry}}</span></label>
                <!-- <label class="text-indent-105">{{destinationAddress}}<span *ngIf="!destinationAddress && destinationCountry != ''">{{destinationCountry}}</span></label> -->
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label"> <span class=" text-bold">Total Shipment Cube(Cubic Feet) : </span>{{shipmentInfo.shipmentCubicFeet?shipmentInfo.shipmentCubicFeet:'No Record'}}</label>
                <!-- <label class="text-indent-105">{{shipmentInfo.shipmentCubicFeet?shipmentInfo.shipmentCubicFeet:'No Record'}}</label> -->
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12"  *ngIf="!isGSSPR">
                <label class="usa-label"><span class=" text-bold">Estimated Mileage : </span>{{shipmentInfo.miles}}</label>
                <!-- <label class="text-indent-105">{{shipmentInfo.miles}}</label> -->
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="isOneTimeShipment">
                <label class="usa-label"> <span class=" text-bold">Tender Id : </span>OTO {{shipmentCostInfo.totalCost | currency}} ON {{bookShipmentInfo.oneTimeOnlyQuoteDate | date: 'MM/dd/yyyy'}} {{bookShipmentInfo.oneTimeOnlyQuoteNumber}}</label>
                <!-- <label class="text-indent-105">OTO {{shipmentCostInfo.totalCost | currency}} ON {{bookShipmentInfo.oneTimeOnlyQuoteDate | date: 'MM/dd/yyyy'}} {{bookShipmentInfo.oneTimeOnlyQuoteNumber}}</label> -->
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="shipmentInfo.noOfFleetVehicles">
                <label class="usa-label"><span class=" text-bold">No. of Fleet Vehicles : </span>{{shipmentInfo.noOfFleetVehicles}}</label>
                <!-- <label class="text-indent-105">{{shipmentInfo.noOfFleetVehicles}}</label> -->
              </div>
              <!-- <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" >
                  <label class="usa-label"><span class=" text-bold">Estimated Weight : </span>{{shipmentInfo.weight}}</label>
              </div> -->
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="!isOneTimeShipment">
                <label class="usa-label"><span class=" text-bold"> SRO : </span>{{ratesSroInfo?.sroId}} - {{ ratesSroInfo?.sroType }}</label>
                <!-- <label class="text-indent-105">{{ ratesSroInfo?.sroType }}</label> -->
              </div>
            </div>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <div class="grid-row grid-gap-1">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="isOneTimeShipment &&  !shipmentInfo.noOfFleetVehicles">
                <label class="usa-label text-bold"> Accessorial Cost :</label>
                <button type="button" class="usa-button" (click)="enterAccessorialModal()"> Accessorials</button>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label text-bold" for="contractOrder">Contract Purchase Order No:</label>
                <button type="button" class="usa-button" id="contractOrder" (click)="openSealOrPurchaseModal('purchaseorder', 'Purchase Orders')">Edit</button>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label text-bold" for="sealNo">Seal Numbers:</label>
                <button type="button" class="usa-button" id="sealNo" (click)="openSealOrPurchaseModal('seal', 'Seal Numbers')">Edit</button>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label text-bold">Enter origin, destination & other addresses</label>
                <button type="button" class="usa-button" (click)="enterAddressModal()">Addresses</button>
                <span *ngIf="allAddressExist">
                                    <svg class="usa-icon define-valid-icon" aria-hidden="true" tooltip="Address info is completed." focusable="false" role="img">
                                        <use xlink:href="/assets/uswds/img/sprite.svg#check_circle"></use>
                                    </svg>
                                </span>
                <span *ngIf="!allAddressExist">
                                    <svg class="usa-icon define-invalid-icon" aria-hidden="true" focusable="false" role="img" tooltip="Incomplete Address info. Please enter all required fields.">
                                        <use xlink:href="/assets/uswds/img/sprite.svg#cancel"></use>
                                      </svg>
                                </span>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="address" class="usa-label text-bold">Enter or edit package information</label>
                <button type="button" class="usa-button" (click)="openPackageModal()" id="address">Package Information</button>
                <span *ngIf="packagesExist">
                                    <svg class="usa-icon define-valid-icon" aria-hidden="true" tooltip="Package info is completed." focusable="false" role="img">
                                        <use xlink:href="/assets/uswds/img/sprite.svg#check_circle"></use>
                                    </svg>
                                </span>
                <span *ngIf="!packagesExist">
                                    <svg class="usa-icon define-invalid-icon" aria-hidden="true" focusable="false" role="img" tooltip="Incomplete Package info. Please enter all required fields.">
                                        <use xlink:href="/assets/uswds/img/sprite.svg#cancel"></use>
                                      </svg>
                                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="grid-row grid-gap-1" *ngIf="!isOneTimeShipment">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <legend class="usa-legend usa-legend--medium">Shipment Cost Information</legend>
            <hr>
          </div>
        </div>

        <div class="grid-row grid-gap-1" *ngIf="!isOneTimeShipment">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <div class="grid-row grid-gap-1">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label"><span class=" text-bold">Type of Rate: </span>{{rateTypesInfo?.description }}</label>
                <!-- <label class="text-indent-105">{{rateTypesInfo?.description }}</label> -->
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label"><span class=" text-bold">Tender Id: </span>{{ ratesFrtInfo?.tenderId }}</label>
                <!-- <label class="text-indent-105">{{ ratesFrtInfo?.tenderId }}</label> -->
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label"><span class=" text-bold">Fuel Surcharge Cost: </span> {{shipmentCostInfo?.fuelSurchargeCost | currency}}</label>
                <!-- <label class="text-indent-105">{{shipmentCostInfo?.fuelSurchargeCost | currency}}</label> -->
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label"><span class=" text-bold">Linehaul Cost :</span>{{shipmentCostInfo?.linehaulCost | currency}}  </label>
                <!-- <label class="text-indent-105">{{shipmentCostInfo?.linehaulCost | currency}} </label> -->
                <div class="text-base" aria-hidden="true">{{linehaulCalculation}}</div>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label"><span class=" text-bold">Total Transportation Cost:</span>{{ shipmentCostInfo?.totalCost | currency }}</label>
                <!-- <label class="text-indent-105">{{ shipmentCostInfo?.totalCost | currency }}</label> -->
              </div>
            </div>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <div class="grid-row">

              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="!shipmentInfo.noOfFleetVehicles">
                <label class="usa-label text-bold">Accessorial Cost : </label>
                <div> {{accessorialCost | currency}}
                  <button type="button" class="usa-button" (click)="enterAccessorialModal()">Accessorials</button>
                </div>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label text-bold">Response from TSP required within :</label>
                <div class="grid-row">
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-3">
                    <select id="tspResponseInDays" class="usa-select" formControlName="tspResponseInDays" (change)="changeTspResponse($event)">
                      <option *ngFor="let number of numberOfDays" value="{{ number }}">{{ number }}</option>
                    </select>
                  </div>
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-3 define-center-text">Days OR</div>
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-3">
                    <select id="tspResponseInHours" class="usa-select" formControlName="tspResponseInHours" (change)="changeTspResponse($event)">
                      <option *ngFor="let number of numberOfHours" value="{{ number }}">{{ number }}</option>
                    </select>
                  </div>
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-3 define-center-text">Hours</div>
                </div>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label">If you are using Off-line booking, please contact the TSP to verify shipment acceptance
                  prior to continuing</label>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 usa-checkbox">
                <input type="checkbox" class="usa-checkbox__input" id="olBooking" formControlName="bookingType" (change)="changeBookingType($event)" />
                <label for="olBooking" class="usa-checkbox__label">Off-Line Booking</label>
              </div>
            </div>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <div class="grid-row">

              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="hazmatInd">
                <label class="usa-label"> <b>Hazmat Contact Info </b>(maximum 100 chars : Please enter your Hazmat Contact Info, if available, otherwise the default contact 1-800-888-8888 will be used.)</label>
                <textarea class="usa-textarea" formControlName="hazmatContactInfo" maxlength="100"></textarea>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label text-bold"> Shipper Additional Comments:(Maximum 500 chars)</label>
                <textarea class="usa-textarea" formControlName="additionalComments" maxlength="500" [attr.disabled]="!isCarrierView?null:true"></textarea>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa-label text-bold">TSP Additional Comments:(Maximum 500 chars)</label>
                <textarea class="usa-textarea" formControlName="tspAdditionalComments" maxlength="500" [attr.disabled]="isCarrierView?null:true"></textarea>
              </div>
            </div>

          </div>
        </div>

        <div class="grid-row grid-gap-1">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <legend class="usa-legend usa-legend--medium">Booking Status: {{ bookShipmentInfo.bookingStatus }}</legend>
          </div>
          <div *ngIf="acceptRejectionWithReason && !isOneTimeShipment"  class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <div class="grid-row grid-gap" id="accept" *ngIf="isAcceptedWithQualificationByCarrier && this.bookShipmentInfo.refusalOrQualificationReason; else isRefusedByCarrier">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label class="usa-label">Acceptance With Qualifications</label>
                <select class="usa-select maxw-full" formControlName="carrierAcceptOption" [attr.disabled]="true">
                  <option *ngFor="let item of carrierAcceptOptions" [value]="item">{{item}}</option>
                </select>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4" *ngIf="this.bookShipmentInfo.refusalOrQualificationRemarks">
                <label class="usa-label">Reason Details</label>
                <input type="text" id="specifyAcceptReason" class="usa-input maxw-full" [attr.disabled]="true" formControlName="carrierAcceptReason">
              </div>
            </div>
            <ng-template #isRefusedByCarrier>
              <div id="refuse" class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="this.bookShipmentInfo.refusalOrQualificationReason;">
                <div class="grid-row grid-gap">
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label class="usa-label">Reason For Refusal</label>
                    <select class="usa-select maxw-full" [attr.disabled]="true" formControlName="carrierRefuseOption">
                      <option *ngFor="let item of carrierRejectOptions" [value]="item">{{item}}</option>
                    </select>
                  </div>
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4" *ngIf="this.bookShipmentInfo.refusalOrQualificationRemarks">
                    <label class="usa-label">Reason Details</label>
                    <input type="text" id="specifyRejectReason" class="usa-input maxw-full" [attr.disabled]="true" formControlName="carrierRefuseReason">
                  </div>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </ng-template>
      <div class="grid-row padding-top-4">
        <ul class="usa-button-group">
          <li class="usa-button-group__item" *ngIf="!(isCarrierView)">
            <button type="button" class="usa-button" (click)="validateConfirm('Y')" *ngIf="!(isCarrierView && bookShipmentInfo.bookingStatus === 'Booked')" [disabled]="this.disabledConfirm || disabled ||(frtOnlineBookShipmentForm.invalid && !isCarrierView)">Confirm</button>
          </li>
          <li class="usa-button-group__item" *ngIf="(isCarrierView)">
            <button type="button" class="usa-button" (click)="validateConfirm('Y')" *ngIf="!(isCarrierView && bookShipmentInfo.bookingStatus === 'Booked')"
                    [disabled]="disabled || (frtOnlineBookShipmentForm.invalid && !isCarrierView)
                                    || !(this.frtOnlineBookShipmentForm.controls['carrierRefuseReason'].valid
                                        && this.frtOnlineBookShipmentForm.controls['carrierRefuseOption'].valid
                                        && this.frtOnlineBookShipmentForm.controls['carrierAcceptReason'].valid
                                        && this.frtOnlineBookShipmentForm.controls['carrierAcceptOption'].valid
                                        && isCarrierView)">Confirm</button>
          </li>
          <li class="usa-button-group__item"><button type="button" class="usa-button" (click)="saveShipment(null)" *ngIf="!(isCarrierView && bookShipmentInfo.bookingStatus === 'Booked')" [disabled]="disabled || (frtOnlineBookShipmentForm.invalid && !isCarrierView)">Save Shipment
            Details</button> </li>
          <li class="usa-button-group__item"> <button type="button" class="usa-button" (click)="viewBillOfLading()" *ngIf="(bookShipmentInfo.bookingStatus === 'Accepted' || bookShipmentInfo.bookingStatus === 'Accepted with Qualification') && !isCarrierView">Continue
            to Bill
            Of Lading Details</button></li>
          <li class="usa-button-group__item"><button type="button" class="usa-button usa-button--outline" (click)="cancelShipment()" [disabled]="disabled" *ngIf="!isCarrierView">Cancel
            Shipment</button> </li>
          <li class="usa-button-group__item"><button type="button" class="usa-button" (click)="viewBookingAuditTrial()">View
            Booking Audit Trail</button> </li>
        </ul>
      </div>
    </form>
  </fieldset>
</div>
